
/**
 * Nettoie un code organisation pour stockage/validation.
 */
export function normalizeOrganizationCode(raw) {
    if (!raw) return ''

    return raw
        .toUpperCase()
        .replace(/[\s.-]/g, '')
}

/**
 * Formatte un code organisation pour affichage utilisateur.
 */
export function formatOrganizationCode(raw) {
    const clean = normalizeOrganizationCode(raw)

    const type = window.DesignSystem.utils.detectOrganizationCodeType(clean)

    switch (type) {

        case 'SIREN':
            // Force le format 123 456 789
            return clean.replace(
                /(\d{3})(\d{3})(\d{0,3})/,
                (_, a, b, c) => [a, b, c].filter(Boolean).join(' ')
            )

        case 'SIRET':
            // Force le format 123 456 789 00001
            return clean.replace(
                /(\d{3})(\d{3})(\d{3})(\d{0,5})/,
                (_, a, b, c, d) => [a, b, c, d].filter(Boolean).join(' ')
            )

        case 'UAI':
            // Pas de formatage
            return clean

        default:
            /**
             * Cas de saisie progressive :
             * on applique un formatage souple numérique qui marche pour les trois
             */

            if (/^\d+$/.test(clean)) {

                if (clean.length <= 9) {
                    return clean.replace(/(\d{3})(?=\d)/g, '$1 ').trim()
                }

                const siren = clean.slice(0, 9)
                const nic = clean.slice(9, 14)

                return [
                    siren.replace(/(\d{3})(?=\d)/g, '$1 ').trim(),
                    nic
                ]
                    .filter(Boolean)
                    .join(' ')
            }

            return clean
    }
}

/**
 * Formatte la valeur ET recalcule la position du curseur.
 */
export function formatOrganizationCodeWithCaret(value, caretPosition) {

    const rawBeforeCaret = value.slice(0, caretPosition)

    const normalizedBeforeCaret = normalizeOrganizationCode(rawBeforeCaret)

    const normalizedFull = normalizeOrganizationCode(value)

    const formatted = formatOrganizationCode(normalizedFull)

    let newCaret = 0
    let rawIndex = 0

    while (
        newCaret < formatted.length &&
        rawIndex < normalizedBeforeCaret.length
        ) {

        if (formatted[newCaret] !== ' ') {
            rawIndex++
        }

        newCaret++
    }

    return {
        formatted,
        raw: normalizedFull,
        caret: newCaret
    }
}
